import { arrayValidation } from 'utils/array';
import type { Column } from 'api/shared/models';

export const getColumnsByConfiguration = (columns: Column[]) => {
  let newAvailableColumns: Column[] = [];
  let newMyColumns: Column[] = [];
  if (arrayValidation(columns)) {
    newAvailableColumns = columns.filter((item) => !item.status);
    newMyColumns = columns.filter((item) => item.status);
  }

  return {
    newAvailableColumns,
    newMyColumns,
  };
};
